export default __webpack_public_path__ + "static/media/shieldTickInProgressYellow.067bdca9.svg";